import { Box } from '@mui/material';

import { Upload } from 'antd';
import useFileUpload from 'hooks/useFileHandler';

function SelectedFilePreview({ file, setFile, setFileRes, image, setImage, setImageRes }) {
	const { deleteFile } = useFileUpload();

	if (image) {
		return (
			<Box sx={{ order: 3, p: '4px 10px ', bgcolor: '#f2f2f2' }}>
				<Box sx={{ width: '100%', overflow: 'hidden', bgcolor: '#ffffff', borderRadius: '5px', p: 1 }}>
					<Box sx={{ '& .ant-upload-list-item-container': { width: '56px', height: '56px' } }}>
						<Upload
							listType="picture-card"
							onRemove={async (removeFile) => {
								// console.log('removeFile', removeFile);
								const payload = {
									fileId: removeFile.response?.fileId,
								};
								await deleteFile(payload, '/delete-by-file-id');
								setImageRes(null);
								setImage(null);
							}}
							fileList={[image]}
							showUploadList={{
								showPreviewIcon: false,
							}}
						/>
					</Box>
				</Box>
			</Box>
		);
	}

	if (file) {
		return (
			<Box sx={{ order: 3, p: '4px 10px ', bgcolor: '#f2f2f2' }}>
				<Box
					sx={{
						width: '100%',
						overflow: 'hidden',
						bgcolor: '#ffffff',
						borderRadius: '5px',
						p: 1,
						'& .ant-upload-list-item': { mt: '0 !important' },
					}}
				>
					<Upload
						listType="picture"
						onRemove={async (removeFile) => {
							// console.log('removeFile', removeFile);
							const payload = {
								fileId: removeFile.response?.fileId,
							};
							await deleteFile(payload, '/delete-by-file-id');
							setFileRes(null);
							setFile(null);
						}}
						fileList={[file]}
					/>
				</Box>
			</Box>
		);
	}

	return null;
}

export default SelectedFilePreview;
